import React from 'react';
import ReactDOMServer from 'react-dom/server';

var TestScenarioAStartText =
	<div>
		<br />Below are the main points that you will be tested on during this scenario:<br />
		<ul>
			<li>Assess the area and ask a bystander to call 911.</li>
			<li>Wear personal protective equipment.</li>
			<li>Select the appropriate pressure dressing.</li>
			<li>Apply the pressure dressing over the wound.</li>
			<li>Apply pressure to the wound with the pressure dressing.</li>
			<li>If the bleeding is not controlled, don’t remove the dressing.</li>
			<li>Reassess for Bleeding Control – after pressure dressing.</li>
		</ul>
		Please tap on the Start Scenario button below to start this test scenario.
	</div>;

var TestScenarioBStartText =
	<div>
		<br />Below are the main points that you will be tested on during this scenario:<br />
		<ul>
			<li>Assess the area and ask a bystander to call 911.</li>
			<li>Wear personal protective equipment.</li>
			<li>Select the appropriate pressure dressing.</li>
			<li>Apply the pressure dressing over the wound.</li>
			<li>Apply pressure to the wound with the pressure dressing.</li>
			<li>If the bleeding is not controlled, don’t remove the dressing.</li>
			<li>Reassess for Bleeding Control – after pressure dressing.</li>
			<li>Identify and apply the 1st tourniquet on the correct location.</li>
			<li>Twist the Rod until the bleeding has stopped.</li>
			<li>Reassess for Bleeding Control – after 1st tourniquet.</li>
			<li>Record time of application of 1st tourniquet.</li>
		</ul>
		Please tap on the Start Scenario button below to start this test scenario.
	</div>;

var TestScenarioCStartText =
<div>
Below are the main points that you will be tested on during this scenario:<br />
<ul>
	<li>Assess the area and ask a bystander to call 911.</li>
	<li>Wear personal protective equipment.</li>
	<li>Select the appropriate pressure dressing.</li>
	<li>Apply the pressure dressing over the wound.</li>
	<li>Apply pressure to the wound with the pressure dressing.</li>
	<li>If the bleeding is not controlled, don’t remove the dressing.</li>
	<li>Reassess for Bleeding Control – after pressure dressing.</li>
	<li>Identify and apply the 1st tourniquet on the correct location.</li>
	<li>Twist the Rod until the bleeding has stopped.</li>
	<li>Reassess for Bleeding Control – after 1st tourniquet.</li>
	<li>Record time of application of 1st tourniquet.</li>
	<li>Identify and apply the 2nd tourniquet on the correct location.</li>
	<li>Twist the Rod until the bleeding has stopped.</li>
	<li>Reassess for Bleeding Control – after 2nd tourniquet.</li>
	<li>Record time of application of 2nd tourniquet.</li>
</ul>
</div>;

var TestScenarioDStartText =
	<div>
		<br />Below are the main points that you will be tested on during this scenario:<br />
		<ul>
			<li>Assess the area and ask a bystander to call 911.</li>
			<li>Wear personal protective equipment.</li>
			<li>Identify and apply the 1st tourniquet on the correct location.</li>
			<li>Twist the Rod until the bleeding has stopped.</li>
			<li>Reassess for Bleeding Control – after 1st tourniquet.</li>
			<li>Record time of application of 1st tourniquet.</li>
			<li>Identify and apply the 2nd tourniquet on the correct location.</li>
			<li>Twist the Rod until the bleeding has stopped.</li>
			<li>Reassess for Bleeding Control – after 2nd tourniquet.</li>
			<li>Record time of application of 2nd tourniquet.</li>
		</ul>
		Please tap on the Start Scenario button below to start this test scenario.
	</div>;

export const getTestAScenario = function(){
	return ReactDOMServer.renderToStaticMarkup(TestScenarioAStartText);
};

export const getTestBScenario = function(){
	return ReactDOMServer.renderToStaticMarkup(TestScenarioBStartText);
};

export const getTestCScenario = function(){
	return ReactDOMServer.renderToStaticMarkup(TestScenarioCStartText);
};

export const getTestDScenario = function(){
	return ReactDOMServer.renderToStaticMarkup(TestScenarioDStartText);
};
